import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../constants/data';
export function MoreTestimonials() {
  const [active, setActive] = useState(0);
  const count = moreTestimonials.length;
  const go = (dir: number) => setActive(prev => (prev + dir + count) % count);
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#111111'
  }} data-id="element-185">
      <div className="mx-auto max-w-6xl" data-id="element-186">
        <Reveal data-id="element-187">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-188">
            +500 Jóvenes ya Cambiaron su Economía
          </h2>
        </Reveal>

        {/* Desktop / tablet grid */}
        <div className="mt-10 hidden sm:grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189">
          {moreTestimonials.map((t, i) => <Reveal key={t.initials} delay={i % 3 * 0.1} data-id="element-190">
              <TestimonialCard t={t} showCityBadge data-id="element-191" />
            </Reveal>)}
        </div>

        {/* Mobile carousel */}
        <div className="mt-10 sm:hidden" data-id="element-192">
          <div className="relative" data-id="element-193">
            <TestimonialCard t={moreTestimonials[active]} showCityBadge data-id="element-194" />
            <div className="mt-5 flex items-center justify-center gap-4" data-id="element-195">
              <button onClick={() => go(-1)} aria-label="Testimonio anterior" className="glass p-2 text-white/70" data-id="element-196">
                <ChevronLeftIcon className="w-5 h-5" data-id="element-197" />
              </button>
              <div className="flex gap-2" data-id="element-198">
                {moreTestimonials.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Ir al testimonio ${i + 1}`} className="h-2 rounded-full transition-all" style={{
                width: i === active ? 20 : 8,
                backgroundColor: i === active ? '#00C853' : 'rgba(255,255,255,0.25)'
              }} data-id="element-199" />)}
              </div>
              <button onClick={() => go(1)} aria-label="Testimonio siguiente" className="glass p-2 text-white/70" data-id="element-200">
                <ChevronRightIcon className="w-5 h-5" data-id="element-201" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}